var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retry-container"},[_c('button',{staticClass:"btn btn-primary-stroked ripple ripple--stroked",on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" تلاش مجدد ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }